import {Col, Row} from "react-bootstrap";
import React, {Component} from "react";
import './Projects.css';

import {portfolioData, sectionHeaders} from "../../../data/data";
import GameCardList from "../../../components/projects-card-list/GameCardList";
import WebAppCardList from "../../../components/projects-card-list/WebAppCardList";

class Projects extends Component {
    render() {
        return (
            <div id='projects' className={'px-4 py-5 mt-5'}>
                {sectionHeaders('projects')}
                <Row className={'py-5'}>
                    <Col md={6}>
                        <span style={{fontSize: '3em'}}><strong>Games</strong></span>
                        <br/><br/>
                        <GameCardList projectList={portfolioData.projects.games}/>
                    </Col>
                    <Col md={6}>
                        <span style={{fontSize: '3em'}}><strong>Web apps</strong></span>
                        <br/><br/>
                        <WebAppCardList projectList={portfolioData.projects.webApps}/>
                    </Col>
                </Row>

            </div>
        );
    }
}

export default Projects;